import React, { Suspense } from 'react'
import { faPencil } from '@fortawesome/free-solid-svg-icons'
import Card from 'src/components/Card'
import useToggleState from 'src/hooks/useToggleState'
import Body from './Body'
import EditModel from './EditModal'
import Skeleton from './Skeleton'

interface NotesProps {
  id: number
}

const Notes: React.FC<NotesProps> = (props) => {
  const { id } = props
  const [isOpen, , handleToggle] = useToggleState()

  return (
    <>
      <Card
        title='Notes'
        primaryAction={{
          key: 'edit',
          icon: faPencil,
          onClick: handleToggle,
          permissionKey: 'CAT_EDIT'
        }}
      >
        <Suspense fallback={<Skeleton />}>
          <Body id={id} />
        </Suspense>
      </Card>
      <EditModel id={id} isOpen={isOpen} toggle={handleToggle} />
    </>
  )
}

export default Notes
